import { render, staticRenderFns } from "./HeaderMenuBlock.vue?vue&type=template&id=14f45403&scoped=true"
import script from "./HeaderMenuBlock.vue?vue&type=script&lang=js"
export * from "./HeaderMenuBlock.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenuBlock.vue?vue&type=style&index=0&id=14f45403&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f45403",
  null
  
)

export default component.exports